<template>
  <v-app>
    <div v-if="authState !== 'signedin'">
      <amplify-authenticator v-bind:authConfig="authConfig">
        <amplify-sign-in slot="sign-in" hide-sign-up="true"></amplify-sign-in>
      </amplify-authenticator>
    </div>

    <div v-if="authState === 'signedin' && user && user_setup">
      <v-app-bar app color="blue" dark dense>
        <v-btn icon>
          <v-icon>mdi-cloud-print-outline</v-icon>
        </v-btn>
        <v-toolbar-title>AI画像粒度解析 {{ date_time }}</v-toolbar-title>

        <v-spacer></v-spacer>
        <h2 v-if="isPlatform('windows')">Windows</h2>
        <h2 v-else>iPad/iPhone</h2>

        <v-spacer></v-spacer>
        <v-btn to="/"     elavation="4" color="indigo">入力</v-btn>
        <v-btn to="/view" elavation="4" color="indigo">表示</v-btn>
      
        <v-menu offset-y>
          <template v-slot:activator="{ on }">
            <v-btn v-on="on" text>設定<v-icon>mdi-menu-down</v-icon></v-btn>
          </template>
          <div v-if='administrator'>
            <v-list>
              <v-list-item v-for="item in items_admin" :key="item.name" :to="item.link">
                <v-list-item-content>
                  <v-list-item-title>{{ item.name }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </div>
          <div v-else>
            <v-list>
              <v-list-item v-for="item in items" :key="item.name" :to="item.link">
                <v-list-item-content>
                  <v-list-item-title>{{ item.name }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </div>
        </v-menu>
      </v-app-bar>

      <v-main>
        <router-view></router-view>
      </v-main>
    
      <v-footer app>
        <v-container>
          <v-row class="mt-n2 pt-0">
            <v-col cols="3">
              <v-btn elavation="4" @click="onClickStart()">起動</v-btn>
            </v-col>
            <v-col cols="3">
              <v-btn elavation="4" @click="onClickStop()">停止</v-btn>
            </v-col>
            <v-col cols="3">
              <div>[{{ instance_status }}]</div>
            </v-col>
            <v-col cols="3">
              <v-btn elavation="4" @click="onClickSignOut" color="orange">サインアウト</v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-footer>
    </div>
  </v-app>
</template>

<script>
import { onAuthUIStateChange } from '@aws-amplify/ui-components'
import axios from "axios";
import { Auth } from 'aws-amplify';

export default {
  name: 'App',

  data(){
    return {
      user: undefined,
      user_name: undefined,
      user_setup: false,
      rank: undefined,
      authState: undefined,
      authConfig: {
        signInConfig: {
          isSignUpDisplayed: false,
        },
      },
      intervalMSec: 10000,
      set_interval_id: undefined,
      unsubscribeAuth: undefined,
      administrator: false,
      group_id: "",
      construct_id: "",
      date_time: "",
      instance_status: "",
      auth_state: "",
      task_status: "",

      inst_change: "",
      inst_status: "",
      messge: "",
      instance_running: false,
      formFields: [
        { type: 'email' },
        { type: 'password' },
      ],
      items: [
        { name: '作業選択',  link: '/const_set' },
        // { name: '領域設定',  link: '/area_set' },
        // { name: '検量線設定',link: '/index_set' },
        { name: 'ジョブ管理',link: '/job_mng' },
      ],
      items_admin: [
        { name: '工事管理',  link: '/group_mng' },
        { name: 'ユーザ情報',link: '/user_all' },
        { name: '作業選択',  link: '/const_set' },
        { name: 'パラメータ',link: '/parameter_mng' },
        { name: 'ジョブ管理',link: '/job_mng' },
      ]
    }
  },
  // beforeDestroy() {
  //   this.unsubscribeAuth();
  // },
  created() {
    // 認証の変化時にアクション状態を返却する
    this.unsubscribeAuth = onAuthUIStateChange((authState, authData) => {
      console.log("onAuthUIStateChange() #STATE:" + authState + " #AUTHDATA:" + authData)
      if (this.auth_state !== authState) {
        this.authState     = authState;
        this.administrator = this.$store.state.administrator;
        this.group_id      = this.$store.state.groupID
        console.log("onAuthUIStateChange() --> #STATE:" + authState)
        console.log("authData:")
        console.log(authData)
        this.auth_state = authState
        if (authData) {
          this.get_user_record(authData.username);
          this.user = authData.username;
          this.$store.state.userID = this.user;
          this.polling_start()

          // ユーザーテーブルをサインイン（稼働中）にする
          this.set_user_state(this.user, "WORKING")

          if (this.$route.path != '/'){
            // ログイン成功したらStoreに格納してindexページに飛ばす
            this.$router.push('/')
          }
        }
        else {
          console.log("---- authData false ----")
          this.polling_stop()
          this.user = undefined
        }
      }
    })
  },

  methods: {
    polling_start  () {
      this.set_interval_id = setInterval(() => {
        if (document.visibilityState === 'visible') {
          this.up_time()
          if (this.auth_state == 'signedin'){
            this.check_instance()
          }
        }
      }, this.intervalMSec)
    },
    polling_stop(){
      console.log("polling_stop() #ID:" + this.set_interval_id)
      clearInterval(this.set_interval_id)
    },
    up_time() {
      var date = new Date();  //new演算子でオブジェクトのインスタンスを生成
        //現在時刻の取得
        this.date_time = date.getHours()+":"+date.getMinutes()+":"+date.getSeconds();
    },
    async set_user_state(user_id, state) {
      console.log("set_user_state() #USER_ID:"+user_id+"["+state+"]")
      try {
        const res = await axios.patch(`${this.$store.state.url}/user/${user_id}`, {
          "label": state,
        },
        {
          headers: {
            Authorization: (await Auth.currentSession()).getIdToken().jwtToken,
          },
        });
        console.log(res)
      } catch (error) {
        alert(error);
      }
    },

    async check_instance() {
      try {
        console.log("async check_instance() #STATE:"+this.auth_state+" #USER:"+this.user)
        if (this.user){
          const res = await axios.post(`${this.$store.state.url}/inst`, {
          },
          {
            headers: {
              Authorization: (await Auth.currentSession()).getIdToken().jwtToken,
            },
          });
          this.task_status = res.data.task_status
          this.inst_change = res.data.inst_change
          this.inst_status = res.data.inst_change
          this.messge      = res.data.message
          
          this.display_task_status(this.task_status)
        }
      } catch(error) {
        console.log(error);      
      }
    },
    // タスクの実行状況を取得して、タスク状態を画面下部右に表示する。
    async check_task() {
      try {
        console.log("async check_instance() #STATE:"+this.auth_state+" #USER:"+this.user)
        const res2 = await axios.get(`${this.$store.state.url}/task/task_01`, {
          headers: {
            Authorization: (await Auth.currentSession()).getIdToken().jwtToken,
          },
        });
        console.log(res2.data.status)
        this.task_status = res2.data.status
      } catch(error) {
        console.log(error);
        return "NG"
      }
      return this.task_status
    },
    display_task_status (task_status) {
      if (task_status == "running") {
        this.instance_status = "運転中"
      }
      else if (task_status == "wait_instance") {
        this.instance_status = "立上げ中"
      }
      else if (task_status == "prepare") {
        this.instance_status = "準備中"
      }
      else if (task_status == "wait") {
        this.instance_status = "停止待"
      }
      else if (task_status == "stop_request") {
        this.instance_status = "停止要求"
      }
      else if (task_status == "shutdown") {
        this.instance_status = "Shutdown"
      }

      else if (task_status == "stop") {
        this.instance_status = "停止中"
      }
      else {
        this.instance_status = task_status
      }
    },
    // 開始ボタンが押下された時に呼び出される。
    // Auth.currentSession() ; ログイン中のユーザーのセッション情報を取得
    // getIdToken().jwtToken ; Cognitoから払い出されたIDトークンを取得
    async onClickStart() {
      try {

        // post:start ; 開始リクエスト
        const res = await axios.post(this.$store.state.url+ "/start", {
        },
        {
          headers: {
            Authorization: (await Auth.currentSession()).getIdToken().jwtToken,
          },
        });
        console.log("RES.DATA" + res.data)
        
        // タスクの実行状況を取得
        const status = await this.check_task()
        console.log("STATUS:" + status)
        
        // タスク状態を画面下部右に表示
        if (status != "NG") {
            this.display_task_status(status)
        }
      } catch(error) {
        console.log(error)
        alert(error);
      }
    },
    // 終了ボタンが押下された時に呼び出される。
    async onClickStop() {
      try {
        // post:stop ; 終了リクエスト
        const res4 = await axios.post(this.$store.state.url + "/stop", {
        },
        {
          headers: {
            Authorization: (await Auth.currentSession()).getIdToken().jwtToken,
          },
        });
        console.log("RES.DATA:" + res4.data)
        
        // タスクの実行状況を取得
        const res2 = await this.check_task()
        
        // タスク状態を画面下部右に表示
        if (res2 != "NG") {
            this.display_task_status(res2)
        }
        //else {
        //  alert(this.task_status)
        //}
      } catch(error) {
        console.log(error)
        alert(error);
      }
    },
    async update_task() {
      // post:stスクテーブルを更新する。
      const res5 = await axios.post(this.$store.state.url + "/task/stop", {
      },
      {
        headers: {
          Authorization: (await Auth.currentSession()).getIdToken().jwtToken,
        },
      });
      this.task_status = res5.data.status
      if (this.task_status == "start") {
        this.instance_status = "運転中"
      }
      else {
        this.instance_status = "準備中"
      }
    },
    async onClickSignOut(){
      try {
        // ユーザーテーブルをサインアウト（停止中）にする
        this.set_user_state(this.user, "STOP")

        await Auth.signOut()

        this.authState     = ""
        this.administrator = false
        this.group_id      = ""
        this.construct_id  = ""
      } catch (error){
        console.log('Signing out error:',error);
      }
    },
    isPlatform: function(platform) {
      var agent = navigator.userAgent.toLowerCase()
      if (agent.indexOf('windows') != -1) {
          this.$store.state.devicePC = true;
      } else {
          this.$store.state.devicePC = false;
      }
      return agent.indexOf(platform) > 0
    },
    async get_user_record(user) {
      try {
        console.log("get_user_record() :" + user)
        const res    = await axios.get(`${this.$store.state.url}/user/${user}`, {
          headers: {
            Authorization: (await Auth.currentSession()).getIdToken().jwtToken,
          },
        });
        console.log("RES: #label:" + res.data.label + "#ID:" + res.data.user_id )
        this.user_label = res.data.name;
        if (res.data.construct_id) {
          this.construct_id = res.data.construct_id
          this.$store.state.constructID   = res.data.construct_id
          this.get_const_record(this.construct_id)
        }

        this.rank = res.data.rank;
        if (this.rank === '0') {
            this.$store.state.administrator = true;
            this.administrator = true;
        } else {
            this.$store.state.administrator = false;
            this.administrator = false;
        }
        console.log("ADMINSTRATOR:"+this.administrator)
      }
      catch(error) {
        console.log("Error! get_user_record() #USER:" + user);
      }
    },
    async get_const_record(const_id) {
      try {
        console.log("get_const_record() :"+const_id)
        const res    = await axios.get(`${this.$store.state.url}/construct/${const_id}`, {
          headers: {
            Authorization: (await Auth.currentSession()).getIdToken().jwtToken,
          },
        });
        console.log(res)
        this.group_id = res.data.group_id;
        this.$store.state.groupID = res.data.group_id
        this.$store.state.constructName = res.data.name
        this.user_setup = true;
        console.log("USER_SETUP:"+this.user_setup)
        console.log("GROUP_ID:" + this.group_id)
      }
      catch(error) {
        alert(error);
      }
    },
  }
};
</script>
